export default __webpack_public_path__ + "static/media/avatar-1.5b019313.png";